const load = namespace => {
  const rawData = localStorage.getItem(namespace)
  if (typeof rawData === "string") {
    return JSON.parse(rawData)
  } else {
    return []
  }
}

const commit = (namespace, values) =>
  localStorage.setItem(namespace, JSON.stringify(values))
const suffix = str => `${str}_storedAt`

/* example usage:
const storage = Storage.for("your-key", {
  firstKey: firstValue,
})

storage.set("firstKey", otherValue)
storage.get("firstKey")
storage.set("secondKey", otherSecValue)
*/
export default class Storage {
  static for(namespace, defaultValues, options) {
    const values = []

    for (const key in defaultValues) {
      values.push([key, defaultValues[key]])
    }

    for (const pair of load(namespace)) {
      values.push(pair)
    }

    return new Storage(values, commit.bind(null, namespace), options)
  }

  constructor(values, commit, options) {
    this.commit = commit
    this.data = new Map(values)
    this.options = options
  }

  get(key, defaultValue) {
    if (this.options?.expiration) {
      const expires = this.data.get(suffix(key)) + this.options?.expiration
      if (expires < new Date().getTime()) {
        this.delete(key)
        return defaultValue
      }
    }
    if (this.data.has(key)) {
      return this.data.get(key)
    } else {
      return defaultValue
    }
  }

  set(key, value) {
    this.data.set(key, value)
    if (this.options?.expiration) {
      this.data.set(suffix(key), new Date().getTime())
    }
    if (this.commit) {
      this.commit(Array.from(this.data))
    }
  }

  delete(key) {
    this.data.delete(key)
    if (this.commit) {
      this.commit(Array.from(this.data))
    }
  }
}
